import { render } from "./TimestampCell.vue?vue&type=template&id=2380a72e&lang=pug"
import script from "./TimestampCell.vue?vue&type=script&lang=ts"
export * from "./TimestampCell.vue?vue&type=script&lang=ts"
script.render = render

export default script